import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=2f14f715&scoped=true&"
import script from "./ModalComment.vue?vue&type=script&lang=ts&"
export * from "./ModalComment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=2f14f715&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14f715",
  null
  
)

export default component.exports